var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "yxt-drawer",
        {
          ref: "selectUser",
          staticClass: "talent-select-thirdparty-user",
          attrs: {
            visible: _vm.drawerVisible,
            size: "960px",
            "before-close": _vm.beforeDrawClose,
            "append-to-body": "",
            title: _vm.$t("pc_gwnl_eval_btn_addTesters" /* 添加测评人员 */),
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawerVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "display-flex gwnl-select__drawer col-flex-1" },
            [
              _c(
                "div",
                { staticClass: "talent-select-thirdparty-user__left pt24" },
                [
                  _c(
                    "div",
                    { staticClass: "display-flex" },
                    [
                      _c("yxtbiz-eval-select-departmenttree", {
                        attrs: {
                          dataPermissionCode: _vm.dataPermissionCode,
                          functionCode: _vm.functionCode,
                        },
                        on: { change: _vm.selectDept },
                      }),
                      _c("yxt-input", {
                        staticClass: "ml12",
                        staticStyle: { width: "240px" },
                        attrs: {
                          placeholder: _vm.$t(
                            "pc_gwnl_jq_enterStudentNameAccount"
                          ),
                          searchable: "",
                          size: "small",
                        },
                        on: {
                          search: function ($event) {
                            return _vm.search()
                          },
                        },
                        nativeOn: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.search()
                          },
                        },
                        model: {
                          value: _vm.keyword,
                          callback: function ($$v) {
                            _vm.keyword = $$v
                          },
                          expression: "keyword",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "mt16 flex-1 overflow-auto" },
                    [
                      _c(
                        "yxt-table",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.loading,
                              expression: "loading",
                            },
                          ],
                          ref: "table",
                          attrs: { data: _vm.list, "row-key": "userId" },
                          on: {
                            select: _vm.handleSelectionChange,
                            "select-all": _vm.handleSelectAll,
                          },
                        },
                        [
                          _c("yxt-table-column", {
                            attrs: {
                              prop: "userId",
                              "reserve-selection": "",
                              type: "selection",
                              width: "55",
                              selectable: function (row) {
                                return row.selectable
                              },
                            },
                          }),
                          _c("yxt-table-column", {
                            attrs: {
                              "min-width": "100",
                              prop: "fullName",
                              label: _vm.$t("pc_gwnl_global_lbl_name"),
                              "show-overflow-tooltip": "",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("yxtbiz-user-name", {
                                      attrs: { name: scope.row.fullName },
                                    }),
                                    _vm._v(
                                      "(" +
                                        _vm._s(scope.row.userName) +
                                        ")\n              "
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("yxt-table-column", {
                            attrs: {
                              label: _vm.$t("pc_gwnl_eval_jobNumber"),
                              prop: "userNo",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(scope.row.userNo || "--") +
                                        "\n              "
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _vm.showModel
                            ? _c("yxt-table-column", {
                                attrs: {
                                  label: _vm.$t("pc_gwnl_model_name"),
                                  prop: "modelName",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                scope.row.modelName || "--"
                                              ) +
                                              "\n              "
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  1258774325
                                ),
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "display-flex align-items-center justify-between mb4",
                    },
                    [
                      _vm.supportSearchAll
                        ? _c(
                            "yxt-button",
                            {
                              staticClass: "lh32",
                              attrs: {
                                type: "text",
                                disabled: _vm.list.length === 0,
                              },
                              on: { click: _vm.searchAll },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("biz_udp_all_filter_results"))
                              ),
                            ]
                          )
                        : _vm._e(),
                      _c(
                        "div",
                        { staticClass: "clearfix" },
                        [
                          _c("yxtbiz-eval-pager", {
                            attrs: {
                              total: _vm.pager.total,
                              page: _vm.pager.offset,
                              limit: _vm.pager.pageSize,
                              layout: "total, prev, pager, next",
                            },
                            on: {
                              "update:total": function ($event) {
                                return _vm.$set(_vm.pager, "total", $event)
                              },
                              "update:page": function ($event) {
                                return _vm.$set(_vm.pager, "offset", $event)
                              },
                              "update:limit": function ($event) {
                                return _vm.$set(_vm.pager, "pageSize", $event)
                              },
                              pagination: _vm.getUserList,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "div",
                { staticClass: "talent-select-thirdparty-user__right" },
                [
                  !_vm.selectedList.length
                    ? _c(
                        "yxt-button",
                        { attrs: { type: "text", disabled: "" } },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.$t("pc_gwnl_global_please_selected") + "..."
                              ) +
                              "\n        "
                          ),
                        ]
                      )
                    : _c(
                        "div",
                        { staticStyle: { height: "100%", overflow: "hidden" } },
                        [
                          _c(
                            "yxt-scrollbar",
                            { attrs: { "fit-height": true } },
                            [
                              _c(
                                "div",
                                _vm._l(
                                  _vm.selectedList,
                                  function (item, index) {
                                    return _c(
                                      "yxt-tag",
                                      {
                                        key: index,
                                        staticClass: "mb10 mr5",
                                        attrs: {
                                          type: "info",
                                          size: "mini",
                                          closable: "",
                                        },
                                        on: {
                                          close: function ($event) {
                                            return _vm.handleSelectionClose(
                                              item
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("yxtbiz-user-name", {
                                          attrs: {
                                            name: item.fullName || "--",
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  }
                                ),
                                1
                              ),
                            ]
                          ),
                          _c(
                            "yxt-button",
                            {
                              staticClass: "result-list__select-clear",
                              attrs: {
                                type: "text",
                                disabled: !_vm.selectedList.length,
                              },
                              on: { click: _vm.clearAllSelection },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("pc_gwnl_global_clearAll")) +
                                  "\n          "
                              ),
                            ]
                          ),
                          _vm.selectedList.length
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "result-list__selected color-gray-8 standard-size-12",
                                },
                                [
                                  _vm._v(
                                    "\n           " +
                                      _vm._s(
                                        _vm.$t(
                                          "pc_gwnl_eval_personCountSelected",
                                          { count: _vm.selectedList.length }
                                        )
                                      ) +
                                      "\n          "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                ],
                1
              ),
            ]
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "yxt-button",
                { attrs: { plain: "" }, on: { click: _vm.cancel } },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("pc_gwnl_global_btn_cancel")) +
                      "\n      "
                  ),
                ]
              ),
              _c(
                "yxt-button",
                { attrs: { type: "primary" }, on: { click: _vm.submit } },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("pc_gwnl_global_btn_next" /* 下一步 */)) +
                      "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }